import React from "react";
import "./homePage.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import {
  FaVial,
  FaClipboardList,
  FaChartLine,
  FaDna,
  FaLock,
} from "react-icons/fa";
import { Link } from "react-router-dom";

function HomePage() {
  const token = localStorage.getItem("token");
  return (
    <>
      <Header />
      <div className="hrt-portal">
        <div className="portal-container">
          <div className="hero-section">
            <div className="hero-content">
              <h1>Welcome to Your HRT Portal</h1>
              <p className="subtitle">
                Your secure hub for hormone health insights. Access your lab
                results, update your symptoms, and explore personalized
                treatment options—all in one place.
              </p>
              {/* <Link to={"https://hrt.org"}>
                <button className="action-button">
                  See More Products At HRT Org <span className="arrow">→</span>
                </button>
              </Link> */}
            </div>
            <div className="hero-image">
              <img
                src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                alt="Medical professional reviewing charts"
              />
            </div>
          </div>

          <div className="card-row">
            <div className="main-card">
              <div className="card-icon">
                <FaVial size={24} />
              </div>
              <h3>Already Have a Test Kit?</h3>
              <p>
                Claim your kit to view your lab results once testing is
                complete.
              </p>
              <Link className="logo" to={token ? "/app/lab-results" : "/"}>
                <button className="action-button">
                  Claim My Kit <span className="arrow">→</span>
                </button>
              </Link>
              <p className="note">
                You do not need to submit additional forms if you are only
                reviewing your test results.
              </p>
            </div>

            <div className="main-card">
              <div className="card-icon">
                <FaClipboardList size={24} />
              </div>
              <h3>Interested in Treatment?</h3>
              <p>
                Complete your medical history for our licensed providers to
                review.
              </p>
              <Link className="logo" to={token ? "/app/medical-history" : "/"}>
                <button className="action-button">
                  Complete Medical History <span className="arrow">→</span>
                </button>
              </Link>
              <p className="note">
                Required for all treatment plans and provider consultations.
              </p>
            </div>

            <div className="main-card">
              <div className="card-icon">
                <FaChartLine size={24} />
              </div>
              <h3>Track Your Symptoms</h3>
              <p>Keep a record of how you're feeling over time.</p>
              <Link className="logo" to={token ? "/app/tracker-history" : "/"}>
              <button className="action-button">
                Update My Symptoms <span className="arrow">→</span>
              </button>
              </Link>
              <p className="note">
                Monitor trends and share with your provider for personalized
                care.
              </p>
            </div>
          </div>
          <div className="next-steps">
            <div className="steps-content">
              <div className="steps-header">
                <FaDna size={28} />
                <h2>What's Next?</h2>
              </div>
              <ul className="steps-list">
                <li>Receive a detailed hormone report</li>
                <li>Get treatment recommendations (if you opted in)</li>
                <li>Refill medications and manage follow-ups</li>
              </ul>
            </div>
            <div className="security-notice">
              <FaLock size={20} />
              <p>
                We follow strict HIPAA compliance standards to protect your
                health data and privacy.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default HomePage;
